import { jsx } from "panel";
import { WarningEl } from "common/components/warning";
export function template() {
  return /* @__PURE__ */ jsx("div", {
    sel: ".warning-hero-container",
    style: this.attr(`margin-override`) ? { margin: `0px` } : {}
  }, /* @__PURE__ */ jsx(WarningEl, {
    attrs: {
      "cta-href": this.attr(`cta-href`),
      "cta-text": this.attr(`cta-text`),
      "header-text": this.attr(`header-text`),
      theme: this.helpers.getTheme(),
      "img-src": this.helpers.getImgSrc(),
      "body-text": this.helpers.getBodyText()
    },
    on: {
      ctaClick: this.helpers.handleCtaClick
    }
  }, /* @__PURE__ */ jsx("slot", null)));
}
